import { inject, Injectable } from '@angular/core';
import {
  extractType,
  getDataSetWidgets,
  getVariableName,
  isNumberType,
  isValidHtml,
  prettifyLabel,
  REGEX,
  stringStartsWith, WIDGET_CONSTANTS
} from '@wms/core';
import {
  cloneDeep,
  each,
  extend,
  filter,
  forEach,
  includes,
  isEmpty,
  isObject,
  isUndefined,
  set, split,
  startsWith, toLower,
  union
} from 'lodash-es';
import { TypeFactoryService } from '../typeFactory/type-factory.service';
import { propFactory as PropertiesFactory } from '@wm/components-base';
import { getClonedObject, isDefined, runtimeEventManager } from '@wm/core';
import {ProjectService, ServiceFactoryService, I18nService} from "@wms/services";
import {LiveVariableUtils} from "@wavemaker/variables";
@Injectable({
  providedIn: 'root'
})
export class LiveWidgetUtilsService {
  isMobileApplicationType;
  isNativeMobileApplicationType;
  variableService: any;
  serviceFactory: ServiceFactoryService;
  VIEW_MODE_OPTIONS = {
    'DEFAULT': 'default',
    'LABEL': 'label'
  }
  defaultNgClassesConfig = { 'className': '', 'condition': '' };
  private i18Service: I18nService;
  isDataSetWidgets: any = getDataSetWidgets()

  constructor(private typeUtils: TypeFactoryService) {
    let projectService = inject(ProjectService);
    this.i18Service = inject(I18nService);
    runtimeEventManager.setService('LiveWidgetUtilsService', this);
    this.variableService = runtimeEventManager.getService('variableService');
    this.serviceFactory = inject(ServiceFactoryService);
    this.isMobileApplicationType = projectService.isMobileApplicationType();
    this.isNativeMobileApplicationType = projectService.isNativeMobileApplicationType();
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#getLiveWidgetButtons
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * return the default button definitions of live form.
 */
  getLiveWidgetButtons(widgetType: any) {
    let defaultButtons;
    switch (widgetType) {
      case 'LIVEFORM':
        defaultButtons = [
          {
            widgetType: 'button',
            key: 'reset',
            class: 'form-reset btn-default',
            iconclass: 'wi wi-refresh',
            action: 'reset()',
            displayName: 'Reset',
            show: 'true',
            type: 'button',
            'position': 'footer',
            updateMode: true,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'cancel',
            class: 'form-cancel btn-default',
            iconclass: 'wi wi-cancel',
            action: 'cancel()',
            displayName: 'Cancel',
            show: 'true',
            type: 'button',
            'position': 'footer',
            updateMode: true,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'save',
            class: 'form-save btn-success',
            iconclass: this.isMobileApplicationType ? 'wi wi-done' : 'wi wi-save',
            action: '',
            displayName: 'Save',
            show: 'true',
            type: 'submit',
            'position': 'footer',
            updateMode: true,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'delete',
            class: 'form-delete btn-danger',
            iconclass: 'wi wi-trash',
            action: 'delete()',
            displayName: 'Delete',
            show: 'true',
            type: 'button',
            'position': 'footer',
            updateMode: false,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'edit',
            class: 'form-update btn-info',
            iconclass: 'wi wi-pencil',
            action: 'edit()',
            displayName: 'Edit',
            show: 'true',
            type: 'button',
            'position': 'footer',
            updateMode: false,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'new',
            class: 'form-new btn-success',
            iconclass: 'wi wi-plus',
            action: 'new()',
            displayName: 'New',
            show: 'true',
            type: 'button',
            'position': 'footer',
            updateMode: false,
            shortcutkey: ''
          }
        ];
        break;
      case 'LIVEFILTER':
        defaultButtons = [
          {
            widgetType: 'button',
            key: 'filter',
            class: 'btn-primary',
            iconclass: 'wi wi-filter-list',
            action: 'filter()',
            displayName: 'Filter',
            show: 'true',
            'position': 'footer',
            type: 'button',
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'clear',
            class: 'btn-default',
            iconclass: 'wi wi-trash',
            action: 'clearFilter()',
            displayName: 'Clear',
            'position': 'footer',
            show: 'true',
            type: 'button',
            shortcutkey: ''
          }];
        break;
      case 'GRID':
        defaultButtons = [
          {
            'widgetType': 'button',
            'key': 'addNewRow',
            'displayName': 'New',
            'iconclass': 'wi wi-plus',
            'show': 'true',
            'class': 'btn-primary',
            'action': 'addNewRow()',
            'position': 'footer',
            shortcutkey: ''
          }
        ];
        break;
      case 'GRIDROW':
        defaultButtons = [
          {
            'key': 'updaterow',
            'displayName': '',
            'title': 'Edit',
            'iconclass': 'wi wi-pencil',
            'show': 'true',
            'class': 'btn-transparent',
            'action': 'editRow($event)'
          },
          {
            'key': 'deleterow',
            'displayName': '',
            'title': 'Delete',
            'iconclass': 'wi wi-trash',
            'show': 'true',
            'class': 'btn-transparent',
            'action': 'deleteRow($event)'
          }
        ];
        break;
      case 'FORM':
        defaultButtons = [
          {
            widgetType: 'button',
            key: 'reset',
            class: 'form-reset btn-default',
            iconclass: 'wi wi-refresh',
            action: '',
            displayName: 'Reset',
            show: 'true',
            type: 'reset',
            position: 'footer',
            updateMode: true,
            shortcutkey: ''
          },
          {
            widgetType: 'button',
            key: 'save',
            class: 'form-save btn-success',
            iconclass: this.isMobileApplicationType ? 'wi wi-done' : 'wi wi-save',
            action: '',
            displayName: 'Save',
            show: 'true',
            type: 'submit',
            position: 'footer',
            updateMode: true,
            shortcutkey: ''
          }
        ];
        break;
    }
    return defaultButtons;
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#fetchPropertiesMapColumns
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * Returns columns and sets related data for provided propertiesMap
 *
 * @param {object} propertiesMap from which columns are retrieved
 * @param {object} relatedData for live filter dataset
 * @param {object} variableObj to which filter is binded
 *
 */
  fetchPropertiesMapColumns(propertiesMap: any, bindDataSet: any) {
    let columns: any = {}, columnName, data: any = {}, primaryKey: any;
    /* iterated trough the propertiesMap columns of all levels and build object with columns having required configuration*/
    forEach(propertiesMap.columns, (val) => {
      /* if the object is nested type repeat the above process for that nested object through recursively */
      if (val.isRelated) {
        if (val.isList) {
          return;
        }
        data.relatedData = data.relatedData || {};
        let relatedTableColumns = this.typeUtils.getFieldsForExpr(bindDataSet + '.' + val.fieldName),
          columnNameTypeMap: any = {};
        each(val.columns, (column) => {
          if (column.isPrimaryKey) {
            primaryKey = column.fieldName;
          }
          columnNameTypeMap[column.fieldName] = column.type;
        });
        data.relatedData[val.relatedEntityName] = {
          columns: relatedTableColumns,
          primaryKey: primaryKey,
          columnNameTypeMap: columnNameTypeMap,
          columnObjs: val.columns
        };

        /* otherwise build object with required configuration */
        columnName = val.fieldName.charAt(0).toLowerCase() + val.fieldName.slice(1);
        columns[columnName] = {};
        columns[columnName].isRelated = val.isRelated === 'true' || val.isRelated === true;
        columns[columnName].relatedEntityName = val.relatedEntityName;
        columns[columnName].relatedPrimaryKey = primaryKey;
      } else {
        /* otherwise build object with required configuration */
        columnName = val.fieldName;
        columns[columnName] = {};
      }
      columns[columnName].type = val.type;
      columns[columnName].isPrimaryKey = val.isPrimaryKey;
      columns[columnName].generator = val.generator;
      columns[columnName].period = val.period;
    });
    return {
      'columns': columns,
      'relatedData': data.relatedData
    };
  }

  parseNgClasses(classExpression: any) {
    let ngClasses: any = [],
      conditionalClasses;
    this.defaultNgClassesConfig = { 'className': '', 'condition': '' };
    /* Return default config. */
    if (!classExpression) {
      ngClasses.push(cloneDeep(this.defaultNgClassesConfig));
      return ngClasses;
    }
    // Removing first occurance of "bind:"
    // Removing curly brackets and get each expression.
    classExpression = classExpression.substring(0, 5) === 'bind:' ? classExpression.substring(5) : classExpression;
    conditionalClasses = classExpression.replace(/^\{(.*)\}$/, "$1").match(REGEX.SPLIT_EXPRESSIONS);
    /* Generate the config. */
    each(conditionalClasses, (conditionalClassConfig) => {
      let conditionalExpression = conditionalClassConfig.match(REGEX.SPLIT_CLASS_NAME),
        className = conditionalExpression[0]?.trim(),
        classCondition = conditionalExpression[1]?.trim(),
        classNameLen = className.length,
        config = cloneDeep(this.defaultNgClassesConfig);
      /* Strip the single quotes from className. */
      if (className[0] === "'" && className[classNameLen - 1] === "'") {
        className = className.substring(1, classNameLen - 1);
      }
      config.className = className;
      config.condition = classCondition;
      ngClasses.push(config);
    });
    return ngClasses;
  }

  setDefaultWidgetConfig(column: any) {
    let widgetType = column.widgetType,
      field = column.field,
      val = column.widgetType === 'button' ? "bind:row.getProperty('" + field + "') || 'Button'" : "bind:row.getProperty('" + field + "')",
      widgetNgClasses = [cloneDeep(this.defaultNgClassesConfig)];
    /* Not storing widget config, it is only on for UI display. Only customExpression will be saved. */
    column.widgetConfig = {};
    switch (widgetType) {
      case 'image':
        column.widgetConfig = {
          'src': val,
          'class': '',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      case 'button':
        column.widgetConfig = {
          'icon': '',
          'action': '',
          'title': val,
          'class': 'btn-sm btn-primary',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      case 'checkbox':
        column.widgetConfig = {
          'model': val,
          'disabled': 'bind:colDef.readonly',
          'class': '',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      case 'anchor':
        column.widgetConfig = {
          'title': val,
          'hyperlink': val,
          'class': '',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      case 'label':
        column.widgetConfig = {
          'title': val,
          'class': '',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      case 'icon':
        column.widgetConfig = {
          'title': val,
          'class': '',
          'icon': 'wi wi-star-border',
          'iconposition': 'left',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
      default:
        column.widgetConfig = {
          'src': val,
          'class': '',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': ''
        };
        break;
    }
  }

  generateNgClassExpression(conditionalClasses: any) {
    let ngClassExpression = '';
    each(conditionalClasses, (config) => {
      if (config.className && config.condition) {
        if (ngClassExpression.length) {
          ngClassExpression += ', ';
        }
        ngClassExpression += "'" + config.className + "':" + config.condition;
      }
    });
    return ngClassExpression.length ? 'bind:' + ngClassExpression : ngClassExpression;
  }

  setColumnCustomExpression(column: any) {
    let widgetNgClassesExpression = this.generateNgClassExpression(column.widgetConfig.ngClasses);
    switch (column.widgetType) {
      case 'image':
        if (column.type === 'blob') {
          column.customExpression = '<wm-picture show="' + column.widgetConfig.src + '!= null" width="48px" picturesource="' + column.widgetConfig.src + '" class="" conditionalclass="" conditionalstyle=""></wm-picture>';
        } else {
          column.customExpression = '<wm-picture picturesource="' + column.widgetConfig.src + '" hint="' + column.widgetConfig.src + '"' +
            ' class="' + column.widgetConfig.class + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-picture>';
        }
        break;
      case 'button':
        column.customExpression = '<wm-button caption="' + column.widgetConfig.title + '" show="true" class="' + column.widgetConfig.class + '" iconclass="' +
          column.widgetConfig.icon + '" on-click="' + column.widgetConfig.action + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-button>';
        break;
      case 'checkbox':
        column.customExpression = '<wm-checkbox datavalue="' + column.widgetConfig.model + '" disabled="' + column.widgetConfig.disabled + '" ' +
          'class = "' + column.widgetConfig.class + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-checkbox>';
        break;
      case 'anchor':
        if (column.type === 'blob') {
          column.customExpression = '<wm-anchor caption="" hyperlink="' + column.widgetConfig.hyperlink + '" target="_blank" iconclass="wm-icon wm-icon24 wi wi-file" class="col-md-9" show="' + column.widgetConfig.hyperlink + '!= null"></wm-anchor>';
        } else {
          column.customExpression = '<wm-anchor caption="' + column.widgetConfig.title + '" hyperlink="' + column.widgetConfig.hyperlink + '" ' +
            'class = "' + column.widgetConfig.class + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-anchor>';
        }
        break;
      case 'label':
        column.customExpression = '<wm-label caption="' + column.widgetConfig.title + '" ' +
          'class = "' + column.widgetConfig.class + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-label>';
        break;
      case 'icon':
        column.customExpression = '<wm-icon caption="' + column.widgetConfig.title + '" iconclass="' + column.widgetConfig.icon + '" iconposition="' + column.widgetConfig.iconposition + '" ' +
          'class = "' + column.widgetConfig.class + '" conditionalclass="' + widgetNgClassesExpression + '" conditionalstyle="' + column.widgetConfig.conditionalstyle + '"></wm-icon>';
        break;
      default:
        if (column.type === 'blob') {
          column.customExpression = '<wm-anchor caption="" hyperlink="' + column.widgetConfig.src + '" target="_blank" iconclass="wm-icon wm-icon24 wi wi-file" class="col-md-9" show="' + column.widgetConfig.src + '!= null"></wm-anchor>';
        }
    }
  }

  /**
  * @ngdoc function
  * @name wm.widgets.live.LiveWidgetUtils#setColumnConfig
  * @methodOf wm.widgets.live.LiveWidgetUtils
  * @function
  *
  * @description
  * Sets the column config for the selected field
  *
  * @param {object} column for which config needs to be set
  */
  setColumnConfig(column: any) {
    /* Not storing ngClasses, it is only on for UI display. Only ngClass expression will be saved. */
    column.ngClasses = this.parseNgClasses(column.ngclass);
    if (!column.customExpression) {
      this.setDefaultWidgetConfig(column);
      this.setColumnCustomExpression(column);
    } else {
      this.extractWidgetConfig(column);
    }
  }

  extractWidgetConfig(column: any) {
    let customExpression = column.customExpression,
      widgetType = column.widgetType,
      widgetDisabled,
      widgetAction,
      widgetIcon,
      widgetTitle,
      widgetClass,
      widgetNgClasses,
      widgetNgStyle,
      widgetSrc,
      widgetModel,
      widgetHyperlink,
      el;
    column.widgetConfig = {};
    /* If custom expression does not contain any HTML tags, append span. */
    if (!isValidHtml(customExpression)) {
      customExpression = '<span>' + customExpression + '</span>';
    }
    el = $(customExpression);

    widgetClass = el.attr('widget-class') || el.attr('class');
    widgetNgClasses = this.parseNgClasses(el.attr('conditionalclass'));
    widgetNgStyle = el.attr('conditionalstyle');
    switch (widgetType) {
      case 'image':
        widgetSrc = el.attr('data-ng-src') || el.attr('picturesource') ||'';
        column.widgetConfig = {
          'src': widgetSrc,
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      case 'button':
        widgetIcon = el.attr('iconclass') || el.attr('iconname') ||'';
        widgetTitle = el.attr('caption') ||'';
        widgetAction = el.attr('on-click') ||'';
        column.widgetConfig = {
          'icon': widgetIcon,
          'action': widgetAction,
          'title': widgetTitle,
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      case 'checkbox':
        widgetModel = el.attr('ng-model') || el.attr('datavalue')||'';
        widgetDisabled =el.attr('ng-disabled') || el.get(0).getAttribute('disabled') ||'';
        column.widgetConfig = {
          'model': widgetModel,
          'disabled': widgetDisabled,
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      case 'anchor':
        widgetTitle = el.attr('caption') ||'';
        widgetHyperlink = el.attr('hyperlink') ||'';
        column.widgetConfig = {
          'title': widgetTitle,
          'hyperlink': widgetHyperlink,
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      case 'label':
        widgetTitle = el.attr('caption') ||'';
        column.widgetConfig = {
          'title': widgetTitle,
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      case 'icon':
        widgetTitle = el.attr('caption') ||'';
        widgetIcon = el.attr('iconclass') ||'';
        column.widgetConfig = {
          'title': widgetTitle,
          'icon': widgetIcon,
          'class': widgetClass,
          'iconposition': el.attr('iconposition') || 'left',
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
      default:
        column.widgetConfig = {
          'src': '',
          'class': widgetClass,
          'ngClasses': widgetNgClasses,
          'conditionalstyle': widgetNgStyle
        };
        break;
    }
  }

  //Populate the filter options with localized messages
  getMatchModeMsgs(appLocale: any) {
    return {
      'start': appLocale.LABEL_STARTS_WITH,
      'startignorecase': appLocale.LABEL_STARTS_WITH_IGNORECASE,
      'end': appLocale.LABEL_ENDS_WITH,
      'endignorecase': appLocale.LABEL_ENDS_WITH_IGNORECASE,
      'anywhere': appLocale.LABEL_CONTAINS,
      'anywhereignorecase': appLocale.LABEL_CONTAINS_IGNORECASE,
      'nowhere': appLocale.LABEL_DOES_NOT_CONTAIN,
      'nowhereignorecase': appLocale.LABEL_DOES_NOT_CONTAIN_IGNORECASE,
      'exact': appLocale.LABEL_IS_EQUAL_TO,
      'exactignorecase': appLocale.LABEL_IS_EQUAL_TO_IGNORECASE,
      'notequals': appLocale.LABEL_IS_NOT_EQUAL_TO,
      'notequalsignorecase': appLocale.LABEL_IS_NOT_EQUAL_TO_IGNORECASE,
      'lessthan': appLocale.LABEL_LESS_THAN,
      'lessthanequal': appLocale.LABEL_LESS_THAN_OR_EQUALS_TO,
      'greaterthan': appLocale.LABEL_GREATER_THAN,
      'greaterthanequal': appLocale.LABEL_GREATER_THAN_OR_EQUALS_TO,
      'null': appLocale.LABEL_IS_NULL,
      'isnotnull': appLocale.LABEL_IS_NOT_NULL,
      'empty': appLocale.LABEL_IS_EMPTY,
      'isnotempty': appLocale.LABEL_IS_NOT_EMPTY,
      'nullorempty': appLocale.LABEL_IS_NULL_OR_EMPTY,
      'in': appLocale.LABEL_IN,
      'notin': appLocale.LABEL_NOT_IN,
      'between': appLocale.LABEL_BETWEEN
    };
  }

  /**
   * @ngdoc function
   * @name wm.widgets.live.LiveWidgetUtils#getMatchModeTypesMap
   * @methodOf wm.widgets.live.LiveWidgetUtils
   * @function
   *
   * @description
   * return the match modes based on the data type
   */
  getMatchModeTypesMap(multiMode: any) {
    let typesMap = {
      'number': ['number', 'integer', 'big_integer', 'short', 'float', 'big_decimal', 'double', 'long', 'byte'],
      'string': ['string', 'text'],
      'character': ['character'],
      'date': ['date', 'time', 'timestamp', 'datetime']
    },
      modes: any = {
        'number': ['exact', 'notequals', 'lessthan', 'lessthanequal', 'greaterthan', 'greaterthanequal', 'null', 'isnotnull'],
        'string': ['anywhereignorecase', 'anywhere', 'nowhere', 'nowhereignorecase', 'startignorecase', 'start', 'endignorecase', 'end', 'exactignorecase', 'exact', 'notequalsignorecase', 'notequals', 'null', 'isnotnull', 'empty', 'isnotempty', 'nullorempty'],
        'character': ['exactignorecase', 'exact', 'notequalsignorecase', 'notequals', 'null', 'isnotnull', 'empty', 'isnotempty', 'nullorempty'],
        'date': ['exact', 'lessthan', 'lessthanequal', 'greaterthan', 'greaterthanequal', 'null', 'notequals', 'isnotnull']
      },
      matchModeTypesMap: any = {
        'boolean': ['exact', 'null', 'isnotnull'],
        'clob': [],
        'blob': []
      };

    if (multiMode) {
      modes.number.push('in', 'notin', 'between');
      modes.date.push('between');
      modes.string.push('in', 'notin');
      modes.character.push('in', 'notin');
    }

    forEach(typesMap, (types, primType) => {
      forEach(types, (type) => {
        matchModeTypesMap[type] = modes[primType];
      });
    });
    //this is used in filter criteria when the user types the column name manually and where we dont know the type of the column
    matchModeTypesMap['default'] = union(modes['number'], modes['string'], modes['character'], modes['date'], modes['date']);
    return matchModeTypesMap;
  }

  /**
   * utility method used for forming the sql query
   * @param group
   * @param i
   * @returns {string}
   */
  getMatchModeString(group: any, i: any) {
    let defaultLocale = this.i18Service.getAppDefaultLocale();
    let appLocale = this.i18Service.getAppLocaleBundle(defaultLocale);
    if (!appLocale || isEmpty(appLocale)) return;
    let matchModeMsgs: any = this.getMatchModeMsgs(appLocale?.systemMessages);

    let matchMode = matchModeMsgs[group.rules[i].matchMode].replace(/\s/ig, "_").toUpperCase(), matchModeVal;
    switch (matchMode) {
      case 'IN':
      case 'NOTIN':
        matchModeVal = matchMode + " (" + group.rules[i].value + ")";
        break;
      case 'BETWEEN':
        matchModeVal = matchMode + " " + group.rules[i].value + " AND " + (group.rules[i].secondvalue ? group.rules[i].secondvalue : "");
        break;
      default:
        matchModeVal = matchMode + " " + group.rules[i].value;
    }
    return matchModeVal;
  }

  /**
   * recursively traverses the filterexpressions object and forms the sql query
   * @param group filterexpressions
   * @returns {string} final sql query
   */
  compute(group: any) {
    if (!group) return "";
    if (group.rules) {
      for (var str = "(", i = 0; i < group.rules.length; i++) {
        i > 0 && (str += " <strong>" + group.condition + "</strong> ");
        str += Array.isArray(group.rules[i].rules) ? this.compute(group.rules[i]) : group.rules[i].target + " " + this.getMatchModeString(group, i);
      }
      return str + ")";
    }
    return "";
  }

  /**
   * used in liveform, livefilter, datatables(inline, quickedit) to show the saved query
   */
  getQuery(filterExpressions: any) {
    return this.compute(filterExpressions ? (isObject(filterExpressions) ? filterExpressions : JSON.parse(filterExpressions)) : {});
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#getFieldTypeWidgetTypesMap
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * return the widget types for liveFilter and liveForm .
 */
  getFieldTypeWidgetTypesMap() {
    let fieldTypeWidgetTypeMap: any = {
      'integer': ['number', 'text', 'select', 'checkboxset', 'radioset', 'rating', 'slider', 'currency', 'autocomplete', 'chips'],
      'big_integer': ['number', 'text', 'select', 'checkboxset', 'radioset', 'rating', 'slider', 'currency', 'autocomplete', 'chips'],
      'short': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'float': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'big_decimal': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'number': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'double': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'long': ['number', 'text', 'select', 'checkboxset', 'radioset', 'rating', 'slider', 'currency', 'autocomplete', 'chips'],
      'byte': ['number', 'text', 'select', 'checkboxset', 'radioset', 'slider', 'currency', 'autocomplete', 'chips'],
      'string': ['text', 'number', 'textarea', 'password', 'richtext', 'select', 'checkboxset', 'radioset', 'date', 'time', 'timestamp', 'switch', 'currency', 'autocomplete', 'chips', 'colorpicker'],
      'character': ['text', 'number', 'textarea', 'password', 'richtext', 'select', 'checkboxset', 'radioset', 'switch', 'currency', 'autocomplete', 'chips'],
      'text': ['text', 'number', 'textarea', 'password', 'richtext', 'select', 'checkboxset', 'radioset', 'date', 'time', 'timestamp', 'switch', 'currency', 'autocomplete', 'chips', 'colorpicker'],
      'date': ['date', 'text', 'number', 'select', 'checkboxset', 'radioset', 'autocomplete', 'chips'],
      'time': ['time', 'text', 'number', 'select', 'checkboxset', 'radioset', 'autocomplete', 'chips'],
      'timestamp': ['timestamp', 'text', 'number', 'select', 'checkboxset', 'radioset', 'autocomplete', 'chips'],
      'datetime': ['datetime', 'text', 'select', 'checkboxset', 'radioset', 'autocomplete', 'chips'],
      'boolean': ['checkbox', 'radioset', 'toggle', 'iconbutton-toggle', 'select'],
      'list': ['select', 'radioset', 'checkboxset', 'switch', 'autocomplete', 'chips'],
      'clob': ['text', 'textarea', 'richtext'],
      'blob': ['upload'],
      'file': ['upload'],
      'custom': ['text', 'number', 'textarea', 'password', 'checkbox', 'toggle', 'slider', 'richtext', 'currency', 'switch', 'select', 'checkboxset', 'radioset', 'date', 'time', 'timestamp', 'rating', 'datetime', 'autocomplete', 'chips', 'colorpicker', 'upload']
    };

    if (this.isNativeMobileApplicationType) {
      let unSupportedWidgets = ['colorpicker', 'richtext', 'upload'];
      forEach(fieldTypeWidgetTypeMap, (types, fieldType) => {
        fieldTypeWidgetTypeMap[fieldType] = filter(types, (widget) => {
          return !includes(unSupportedWidgets, widget);
        });
      });
    }

    return fieldTypeWidgetTypeMap;
  }

  /**
  * @ngdoc function
  * @name wm.widgets.live.LiveWidgetUtils#translateVariableObject
  * @methodOf wm.widgets.live.LiveWidgetUtils
  * @function
  *
  * @description
  * consumes the raw object received from LiveVariable and returns consumable field objects agains each column.
  *
  * @param {object} rawObject data object received from the LiveVariable
  * @param {object} widget scope Caller Widget scope (optional)
  */
  translateVariableObject(rawObject: any, scope?: any) {
    let translatedObj: any = [],
      columnArray = rawObject.propertiesMap ? rawObject.propertiesMap.columns : undefined,
      fieldNames: any = [],
      widgetsMap = this.getFieldTypeWidgetTypesMap();

    if (scope) {
      scope.propertiesMap = rawObject.propertiesMap;
      scope.columnArray = scope.propertiesMap.columns;
      scope.primaryKey = scope.primaryKey || [];
    }
    each(columnArray, (fieldObj) => {
      if (fieldObj.systemInserted || fieldObj.systemUpdated) {
        return;
      }
      let column: any;
      if (!includes(fieldNames, fieldObj.fieldName) && !fieldObj.readonly) {
        fieldNames.push(fieldObj.fieldName);
        column = {
          'displayname': prettifyLabel(fieldObj.fieldName),
          'show': true,
          'primaryKey': fieldObj.isPrimaryKey,
          'generator': fieldObj.generator,
          'period': fieldObj.period,
          'key': fieldObj.fieldName,
          'value': '',
          'type': fieldObj.isRelated ? 'list' : fieldObj.fullyQualifiedType,
          'maxvalue': '',
          'isRelated': fieldObj.isRelated,
          'readonly': fieldObj.isPrimaryKey,
          'required': fieldObj.notNull === 'true' || fieldObj.notNull === true,
          'pcDisplay': true,
          'mobileDisplay': true,
          'tabletDisplay': true
        };
        if (isNumberType(column.type)) {
          column.step = this.getStepValue(fieldObj);
        }
        column.widget = widgetsMap[column.type || 'custom'][0];
        if (fieldObj.defaultValue) {
          column.defaultvalue = this.getDefaultValue(fieldObj.defaultValue, fieldObj.type);
        }
        if (fieldObj.length > 0 && (fieldObj.type === 'string' || fieldObj.type === 'character' || fieldObj.type === 'text' || fieldObj.type === 'blob' || fieldObj.type === 'clob')) {
          column.maxchars = fieldObj.length;
        }
        if (fieldObj.isPrimaryKey) {
          /*If the field has assigned generator, make read only false*/
          if (fieldObj.generator === 'assigned') {
            column.readonly = false;
          } else {
            /*Hiding primary if it is generated automatically(User can un-hide it from edit feilds dialog)*/
            column.show = false;
          }
        }
        translatedObj.push(column);
      }
    });
    return translatedObj;
  }

  /*Returns step attribute value based on input type*/
  getStepValue(fieldObj: any) {
    return fieldObj.scale ? Math.pow(10, fieldObj.scale * -1) : 0;
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#getDefaultValue
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * return the formatted default value
 *
 * @param {string} value value to be formatted
 * @param {string} type column type of the value
 */
  getDefaultValue(value: any, type: any, widget?: any) {
    if (startsWith(value, 'bind:')) {
      return value;
    }
    if (widget) {
      if (widget === 'number' || widget === 'slider' || widget === 'currency') {
        return isNaN(Number(value)) ? null : Number(value);
      }
      if (widget === 'checkbox' || widget === 'toggle' || widget === 'iconbutton-toggle') {
        return this.formatBooleanValue(value);
      }
      return value;
    }
    if (isNumberType(type)) {
      return isNaN(Number(value)) ? null : Number(value);
    }
    if (type === 'boolean') {
      return this.formatBooleanValue(value);
    }
    return value;
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#formatBooleanValue
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * return the formatted boolean value
 *
 * @param {string} value value to be formatted
 */
  formatBooleanValue(value: any) {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
    if (/^\d+$/.test(value)) { //Check if the value is a string of number type like '123'
      return +value;
    }
    return value;
  }

  // function to get view mode widgets for grid
  getViewModeWidgets() {
    return ['image', 'button', 'checkbox', 'label', 'anchor', 'icon'];
  }

  /**
  * @ngdoc function
  * @name wm.widgets.live.LiveWidgetUtils#getCustomFieldKey
  * @methodOf wm.widgets.live.LiveWidgetUtils
  * @function
  *
  * @description
  * returns the auto incremented event string based on the already existing events
  *
  * @param {object} fields array of the columns/ buttons
  * @param {string} key key where the field name is stored in object
  * @param {string} prefix name for the event/ action
  */
  getCustomFieldKey(fields: any, key: any, prefix: string, definedKeys?: any) {
    var keys = definedKeys || fields.map((event: any) => {
      return event[key];
    }), index;
    if (keys && includes(keys, prefix)) {
      index = 1;
      while (includes(keys, prefix + index)) {
        index += 1;
      }
      prefix = prefix + index;
    }
    return prefix;
  }

  getRowOperationsColumn() {
    return {
      'field': 'rowOperations',
      'type': 'custom',
      'displayName': 'Actions',
      'width': '120px',
      'readonly': true,
      'sortable': false,
      'searchable': false,
      'resizable': false,
      'selectable': false,
      'show': true,
      'operations': [],
      'opConfig': {},
      'pcDisplay': true,
      'mobileDisplay': true,
      'tabletDisplay': true,
      'include': true,
      'isRowOperation': true
    };
  }

  getFormWidgetType(widgetType: string) {
    let _wType = '';
    switch (widgetType) {
      case 'textarea':
        _wType = 'wm-textarea';
        break;
      case 'toggle':
      case 'checkbox':
      case 'iconbutton-toggle':
        _wType = 'wm-checkbox';
        break;
      case 'slider':
        _wType = 'wm-slider';
        break;
      case 'colorpicker':
        _wType = 'wm-colorpicker';
        break;
      case 'chips':
        _wType = 'wm-chips';
        break;
      case 'custom-widget':
        _wType = 'wm-custom-widget';
        break;
      case 'richtext':
        _wType = 'wm-richtexteditor';
        break;
      case 'select':
        _wType = 'wm-select';
        break;
      case 'checkboxset':
        _wType = 'wm-checkboxset';
        break;
      case 'radioset':
        _wType = 'wm-radioset';
        break;
      case 'date':
        _wType = 'wm-date';
        break;
      case 'time':
        _wType = 'wm-time';
        break;
      case 'datetime':
      case 'timestamp':
        _wType = 'wm-datetime';
        break;
      case 'rating':
        _wType = 'wm-rating';
        break;
      case 'upload':
        _wType = 'wm-upload';
        break;
      case 'switch':
        _wType = 'wm-switch';
        break;
      case 'currency':
        _wType = 'wm-currency';
        break;
      case 'number':
        _wType = 'wm-number';
        break;
      case 'typeahead':
      case 'autocomplete':
        _wType = 'wm-search';
        break;
      default:
        _wType = 'wm-text';
        break;
    }
    return _wType;
  }


  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#getWidgetProps
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * Get the respective widget properties for the widget
 *
 * @param {string} widgetType type of the widget
 */
  getWidgetProps(widgetType: any, fieldType: any = 'wm-form-field', widgetSubType?: any) {
    var widgetProps: any,
      baseProperties,
      extendedProperties,
      textWidgets = ['text', 'password'],
      setDefaultValueProps = function () {
        /*Use default value instead of datavalue for fields*/
        var defaultProp = 'datavalue';
        if (widgetProps[defaultProp]) {
          widgetProps.defaultvalue = cloneDeep(widgetProps[defaultProp]);
          widgetProps.defaultvalue.bindable = 'in-bound';
          widgetProps[defaultProp].show = false;
        }
      };
    widgetType = widgetType.toLowerCase();
    let _wType = this.getFormWidgetType(widgetType);
    let wp = PropertiesFactory.getWidgetProperties(widgetSubType);
    if (fieldType)
    widgetProps = wp ? wp : PropertiesFactory.getWidgetProperties(_wType);
    widgetProps.displayname = { 'type': "string", 'show': true, 'bindable': "in-bound" };
    widgetProps.widget = { 'type': 'label', 'show': true, 'class': "form-control-static" };

    if (includes(textWidgets, widgetType)) {
      /*In form and filter, type conflicts with data type. Change the type to input type.*/
      widgetProps.inputtype = cloneDeep(widgetProps.type);
      delete widgetProps.type;
    } else if (this.isDataSetWidgets[widgetType]) {
      // on save of formfields from adv settings, dataset expression '' change handler is triggered and resetProps is invoked.
      // its clearing the binding related to datafield, displayexpression those are set on adv settings.
      widgetProps.dataset.value = undefined;
      widgetProps.datafield.value = '';
      if (widgetType === 'autocomplete') {
        widgetProps.type.show = false;
      }
      widgetProps.limit = { 'type': 'number', 'show': true };

      if (fieldType === 'wm-form-field' && widgetProps.datavalue) {
        widgetProps.datavalue.getTypeFrom = 'expr:getDataValueType()';
      }
    } else if (widgetType === 'upload') {
      widgetProps = extend(widgetProps, {
        'readonly': { 'type': 'boolean', 'bindable': 'in-bound', 'show': true },
        'filetype': { 'type': 'data-list', 'options': ['image', 'audio', 'video'], 'show': true },
        'extensions': { 'type': 'string', 'show': true },
        'onTap': { 'show': false }
      });
    } else if (widgetType === 'toggle' || widgetType === 'iconbutton-toggle') {
      widgetProps.caption.show = false;
    }

    setDefaultValueProps();

    if (fieldType === 'wm-form-field') {
      widgetProps.validationmessage = { 'type': "string", 'bindable': "in-bound" };
      widgetProps.validationmessage.show = widgetProps.required && widgetProps.required.show;
      widgetProps['maxplaceholder'] = {type: "string", bindable: "in-bound", show: false};
    } else if (fieldType === 'wm-filter-field') {
      widgetProps.maxplaceholder = { 'type': "string", 'bindable': "in-bound", "show": true };
      widgetProps.maxdefaultvalue = cloneDeep(widgetProps.defaultvalue) || {};
    }

    /*No support for scopedatavalue and scopedataset for fields yet*/
    if (widgetProps.scopedatavalue) {
      delete widgetProps.scopedatavalue;
    }
    if (widgetProps.scopedataset) {
      delete widgetProps.scopedataset;
    }
    //Ignore the default getter setter on in out bound properties as it is set explicitly for form field
    forEach(widgetProps, (prop) => {
      let isStudioMode = true; // TODO: remove
      if (!isStudioMode && (prop.bindable === 'in-out-bound' || prop.bindable === 'out-bound')) {
        set(prop, 'ignoreGetterSetters', true);
      }
    });
    return widgetProps;
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.getDefaultViewModeWidget
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * Returns the default value for view mode widget in live form
 *
 * @param {widget} widget form field widget
 */
  getDefaultViewModeWidget(widget: any) {
    if (includes(['checkbox', 'toggle', 'iconbutton-toggle', 'rating', 'upload'], widget)) {
      return this.VIEW_MODE_OPTIONS.DEFAULT;
    }
    return this.VIEW_MODE_OPTIONS.LABEL;
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#mergeDimension
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * sets width or height from the value and unit
 *
 * @param {object} column column or field definition
 * @param {string} type width or height
 */
  mergeDimension(column: any, type: any) {
    /*if width is given and a number set it*/
    switch (type) {
      case 'width':
        if (isDefined(column.widthValue) && column.widthValue !== '' && !isNaN(column.widthValue)) {
          column.width = column.widthValue + column.widthUnit;
        } else if (!column.widthValue || (!column.widthValue.length && stringStartsWith(column.width, column.widthValue))) {
          /* Reset the width to default value when the widthValue is cleared from the UI. */
          column.width = undefined;
        }
        column.widthValue = undefined;
        column.widthUnit = undefined;
        break;
      case 'height':
        if (isDefined(column.heightValue) && column.heightValue !== '' && !isNaN(column.heightValue)) {
          column.height = column.heightValue + column.heightUnit;
        } else if (!column.heightValue || (!column.heightValue.length && stringStartsWith(column.width, column.heightValue))) {
          /* Reset the height to default value when the heightValue is cleared from the UI. */
          column.height = undefined;
        }
        column.heightValue = undefined;
        column.heightUnit = undefined;
        break;
    }
  }

  /*Returns row defs attributes to grid*/
  getRowDef(attrs: any) {
    return {
      'content': attrs.content,
      'expandicon': attrs.expandicon,
      'collapseicon': attrs.collapseicon,
      'position': attrs.position || '0',
      'closeothers': isUndefined(attrs.closeothers) ? 'true' : (attrs.closeothers || 'false'),
      'height': attrs.height,
      'onBeforerowexpand': attrs.onBeforerowexpand,
      'onRowexpand': attrs.onRowexpand,
      'onBeforerowcollapse': attrs.onBeforerowcollapse,
      'onRowcollapse': attrs.onRowcollapse,
      'widgetType': attrs.widgetType || 'button',
      'displayName': attrs.displayName,
      'expandtitle': attrs.expandtitle ,
      'collapsetitle': attrs.collapsetitle ,
      'show': isUndefined(attrs.show) ? 'true' : (attrs.show || 'false'),
      'disabled': attrs.disabled || 'false',
      'class': attrs.class,
      'columnwidth': attrs.columnwidth || '50px'
    };
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.LiveWidgetUtils#splitDimension
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * extracts value and unit from the given width or height
 *
 * @param {object} column column pr field definition
 * @param {string} type width or height
 */
  splitDimension(column: any, type: any) {
    var value,
      unit,
      width,
      height,
      getValue = (val: any) => {
        val = parseInt(val, 10);
        return isNaN(val) ? '' : val;
      };
    switch (type) {
      case 'width':
        /*extract the width and width unit from width*/
        width = column.width || '';
        value = getValue(width);
        unit = width.indexOf('%') === -1 ? 'px' : '%';

        column.widthValue = value;
        column.widthUnit = unit;
        break;
      case 'height':
        /*extract the width and width unit from width*/
        height = column.height || '';
        value = getValue(height);
        unit = height.indexOf('%') === -1 ? 'px' : '%';

        column.heightValue = value;
        column.heightUnit = unit;
        break;
    }
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.getEditModeWidget
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * This function returns the default widget for grid
 *
 * @param {object} colDef field definition
 */
  getEditModeWidget(colDef: any) {
    var fieldTypeWidgetTypeMap = this.getFieldTypeWidgetTypesMap();
    if (colDef.relatedEntityName && colDef.primaryKey) {
      return 'select';
    }
    return (fieldTypeWidgetTypeMap[colDef.type] && fieldTypeWidgetTypeMap[colDef.type][0]) || 'text';
  }

  /**
 * @ngdoc function
 * @name wm.widgets.live.getDataTableFilterWidget
 * @methodOf wm.widgets.live.LiveWidgetUtils
 * @function
 *
 * @description
 * Get the default filter widget type
 *
 * @param {string} type data type of the field
 */
  getDataTableFilterWidget(type: string) {
    var fieldTypeWidgetTypeMap = this.getFieldTypeWidgetTypesMap(),
      widget = fieldTypeWidgetTypeMap[type] && fieldTypeWidgetTypeMap[type][0];
    if (type === 'boolean') {
      widget = 'select';
    }
    if (includes(['text', 'number', 'select', 'autocomplete', 'date', 'time', 'datetime'], widget)) {
      return widget;
    }
    return 'text';
  }

  getCustomizedOptions(activeWidget: any,prop: any, fields: any) {

    let parts    = split(activeWidget.binddataset, /\W/),
      variable = this.variableService.getVariableByName(parts[2]),
      isBoundToServiceVariable = variable && variable.category === 'wm.ServiceVariable';
    if (prop === 'searchkey') {
      // return service query param if bound to service variable.
      if (isBoundToServiceVariable) {
        return this.getServiceParams(activeWidget, variable, fields);
      }
      return fields;
    }
  }

  async getServiceParams(activeWidget: any, variable: any, fields: any) {
    let queryParams = [];
    let searchOptions = [];

    try {
      const serviceOperationInfo = await this.serviceFactory.getServiceOperationInfo(variable.operation, variable.service);
      queryParams = this.variableService.getMappedServiceQueryParams(serviceOperationInfo?.parameters);

      // don't update search options if there is no query service param
      if (queryParams && queryParams.length > 0) {
        searchOptions = queryParams.map((value: any) => value);
      }

      return searchOptions.length ? searchOptions : fields;
    } catch (error) {
      throw error;
    }
  }

  showOrHideMatchProperty($is: any, wp: any) {
    let matchDataTypes  = ['string', 'date', 'time', 'datetime', 'timestamp'],
      matchServiceDataTypes  = ['java.lang.String', 'java.sql.Date', 'java.sql.Time', 'java.sql.Datetime', 'java.sql.Timestamp'];

    let variableName = getVariableName($is),
      variable = this.variableService.getVariableByName(variableName),
      variableCategory = variable && variable.category;

    if (!$is.binddataset || $is.groupby === WIDGET_CONSTANTS.EVENTS.JAVASCRIPT) {
      return;
    }

    if (!$is.groupby || includes($is.groupby, '(')) {
      wp.match.show = false;
    } else if (variableCategory) {
      if (variableCategory === 'wm.LiveVariable') {
        wp.match.show = includes(matchDataTypes, toLower(extractType(this.typeUtils.getTypeForExpression($is.binddataset + '.' + $is.groupby))));
      } else if (variableCategory === 'wm.DeviceVariable') {
        wp.match.show = includes(matchDataTypes, LiveVariableUtils.getFieldType(variableName, $is.groupby));
      } else if (variableCategory === 'wm.ServiceVariable' || variableCategory === 'wm.Variable' || variableCategory === 'wm.CrudVariable') {
        wp.match.show = includes(matchServiceDataTypes, this.typeUtils.getTypeForExpression($is.binddataset + '.' + $is.groupby));
      }
    }
    if (!wp.match.show) {
      runtimeEventManager.emit('set-markup-attr',{widgetId: $is.widgetId, 'match': ''})
      $is.match = '';
    }
    let groupByFlag = ($is.groupby ? true : false);

    if (wp.showcount) {
      wp.showcount.show = groupByFlag;
    }

    if (wp.collapsible) {
      wp.collapsible.show = groupByFlag;
    }

    if (wp.collapsible && !wp.collapsible.show) {
      // $rootScope.$emit('set-markup-attr', $is.widgetid, { 'collapsible': '' });
      $is.collapsible = false;
    }

    if (wp.showcount && !wp.showcount.show) {
      // $rootScope.$emit('set-markup-attr', $is.widgetid, { 'showcount': '' });
      $is.showcount = false;
    }
  };
}
